// extracted by mini-css-extract-plugin
module.exports = {"cardBackground":"CardWithImage-module--card-background--209-G","cardScale":"CardWithImage-module--card-scale--1RIV8","cardImage":"CardWithImage-module--card-image--_Yy5j"};